<template>
  <div
    class="
      tw-font-sans
      tw-flex-wrap
      tw-border-solid
      tw-border-sf-snow-dark
      tw-border-b
      tw-border-x-0
      tw-border-t-0
      last:tw-border-b-0
    "
  >
    <div
      class="tw-flex-row tw-flex tw-justify-between tw-items-center tw-gap-x-4"
      :class="listItemClass"
      @click="handleClick"
    >
      <div
        class="tw-items-center tw-gap-x-4 tw-min-w-0"
        :class="titleContainersClass"
      >
        <div
          class="
            tw-grow-0
            tw-shrink-0
            tw-flex
            tw-items-center
            tw-justify-center
            tw-bg-sf-neutral-subtle-2
            tw-rounded
            empty:tw-hidden
          "
          :style="iconStyle"
        >
          <slot name="icon"></slot>
        </div>
        <div class="tw-min-w-0">
          <div class="tw-flex tw-flex-row tw-gap-x-2">
            <div class="tw-min-w-0" :class="titleClass">
              <slot v-if="$slots.title" name="title"></slot>
              <span
                v-else
                class="tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis"
                >{{ title }}</span
              >
            </div>
            <div class="tw-flex tw-shrink-0 tw-gap-x-2 empty:tw-hidden">
              <slot name="labels"></slot>
            </div>
          </div>
          <div class="tw-flex tw-flex-wrap tw-gap-x-2 empty:tw-hidden">
            <slot name="subtitles"></slot>
          </div>
        </div>
      </div>
      <div class="tw-flex empty:tw-hidden">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup generic="ID extends string | number | null">
import { computed } from 'vue'

interface Props {
  title?: string
  selected?: boolean
  disabled?: boolean
  compact?: boolean
  itemId?: ID
  extraListItemClass?: string
  fullWidthTitle?: boolean
  iconSize?: number
}

type ClickEvent = {
  itemId: Props['itemId']
}

const props = withDefaults(defineProps<Props>(), {
  selected: false,
  disabled: false,
  compact: false,
  itemId: undefined,
  title: undefined,
  extraListItemClass: '',
  fullWidthTitle: false,
  iconSize: 28,
})

const emit =
  defineEmits<{
    'item-click': [payload: ClickEvent]
  }>()

const handleClick = () => {
  emit('item-click', { itemId: props.itemId })
}

const listItemClass = computed(() => {
  const paddingClass = props.compact
    ? `tw-py-2 tw-px-4 ${props.extraListItemClass}`
    : `tw-p-4 ${props.extraListItemClass}`

  if (props.selected) {
    return `${paddingClass} tw-bg-sf-primary-subtle hover:tw-bg-sf-primary-subtle`
  }

  if (props.disabled) {
    return `${paddingClass} tw-bg-sf-snow-light hover:tw-bg-sf-snow-light tw-cursor-not-allowed`
  }

  return `${paddingClass} hover:tw-bg-sf-snow-light`
})

const iconStyle = computed(() => ({
  height: `${props.iconSize}px`,
  width: `${props.iconSize}px`,
}))

const titleClass = computed(() => {
  const titleWidthClass = props.fullWidthTitle ? 'tw-flex-1' : 'tw-min-w-0'
  const disabledClass = props.disabled
    ? 'tw-text-sf-neutral-light-2'
    : 'tw-text-sf-neutral-dark-1'

  return `${titleWidthClass} ${disabledClass}`
})

const titleContainersClass = computed(() => {
  return props.fullWidthTitle ? 'tw-flex-1' : 'tw-flex'
})
</script>
